export default "__VITE_ASSET__D$lQxA_0__"